export default __webpack_public_path__ + "static/media/free-contact.8f9f562c.png";